<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import { DIAGRAM_DEFAULT_WATERMARK, DIAGRAM_ZOOMS } from 'dbgate-tools';
  import FormCheckboxField from '../forms/FormCheckboxField.svelte';

  import FormProviderCore from '../forms/FormProviderCore.svelte';
  import FormSelectField from '../forms/FormSelectField.svelte';
  import FormTextField from '../forms/FormTextField.svelte';

  export let values;

  export let tableCounts;
</script>

<FormProviderCore {values}>
  <FormSelectField
    defaultValue=""
    name="filterColumns"
    label="Show columns"
    data-testid="DiagramSettings_filterColumns"
    isNative
    options={[
      {
        value: '',
        label: 'All',
      },
      {
        value: 'primaryKey',
        label: 'Primary Key',
      },
      {
        value: 'allKeys',
        label: 'All Keys',
      },
      {
        value: 'notNull',
        label: 'Not Null',
      },
      {
        value: 'keysAndNotNull',
        label: 'Keys And Not Null',
      },
    ]}
  />

  <FormSelectField
    defaultValue="1"
    name="zoomKoef"
    data-testid="DiagramSettings_zoomKoef"
    label="Zoom"
    isNative
    options={DIAGRAM_ZOOMS.map(koef => ({
      value: koef.toString(),
      label: `${Math.round(koef * 100)} %`,
    }))}
  />

  <FormCheckboxField name="showNullability" label="Show NULL/NOT NULL" data-testid="DiagramSettings_showNullability" />
  <FormCheckboxField name="showDataType" label="Show data type" data-testid="DiagramSettings_showDataType" />

  <FormTextField name="columnFilter" label="Column filter" />

  <div class="info">
    Tables: {tableCounts?.filtered ?? 0} / {tableCounts?.all ?? 0}
  </div>

  <FormTextField name="tableFilter" label="Table filter" />

  <FormTextField name="omitTablesFilter" label="Omit tables" />

  <FormTextField name="topTables" label="Only N most important tables" type="number" />

  <FormCheckboxField
    name="omitExportWatermark"
    label="Omit export watermark"
    data-testid="DiagramSettings_skipExportWatermark"
  />
  <FormTextField
    name="exportWatermark"
    label="Export watermark"
    placeholder={DIAGRAM_DEFAULT_WATERMARK}
    data-testid="DiagramSettings_exportWatermark"
    disabled={$values.omitExportWatermark}
  />
</FormProviderCore>

<style>
  .info {
    margin-left: var(--dim-large-form-margin);
    color: var(--theme-font-3);
  }
</style>
